import { Sheet } from "tamagui";
import { useState } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function LmSheet({
  hideHandle,
  children,
  fullScreen,
  snapPoints = [85, 50, 25],
  enableScroll,
  scrollviewProps,
  ...sheetProps
}) {
  const [position, setPosition] = useState(0);
  return /* @__PURE__ */ jsxs(
    Sheet,
    {
      modal: !0,
      dismissOnSnapToBottom: !0,
      ...sheetProps,
      snapPoints: fullScreen ? [100, 0] : snapPoints,
      disableDrag: fullScreen ? !0 : sheetProps.disableDrag,
      position,
      onPositionChange: setPosition,
      children: [
        !fullScreen && /* @__PURE__ */ jsx(Sheet.Overlay, {}),
        !hideHandle && !fullScreen && /* @__PURE__ */ jsx(Sheet.Handle, {}),
        /* @__PURE__ */ jsx(Sheet.Frame, { flex: 1, padding: "$4", borderRadius: fullScreen ? 0 : void 0, children: enableScroll ? /* @__PURE__ */ jsx(Sheet.ScrollView, { ...scrollviewProps, children }) : /* @__PURE__ */ jsx(Fragment, { children }) })
      ]
    }
  );
}
export {
  LmSheet
};
//# sourceMappingURL=LmSheet.js.map
